import axios from "axios";
import ApiCall from "utils/ApiCall";

export type UserHotel = {
  hotelId: string;
  hotelName: string;
};

export const getUserHotels = async (): Promise<UserHotel[]> => {
  const route = `${process.env.REACT_APP_API}/users/authed/hotels`;
  try {
    const response = await axios.get(route, {
      headers: {
        Authorization: `Bearer ${localStorage.accessToken}`,
      },
    });
    return response.data;
  } catch (err: any) {
    console.error(`get user hotels err: ${err}`);
    return [];
  }
};

const getHotelById = async (hotelId?: string) => {
  try {
    const hotel = await ApiCall.get(
      `${process.env.REACT_APP_API}/hotels/${hotelId}`
    );
    return {
      ...hotel,
    };
  } catch (err) {
    throw err;
  }
};

const getBookingByConfirmationNumber = async (confirmationNumber?: string) => {
  try {
    return await ApiCall.get(
      `${process.env.REACT_APP_API}/bookings?bookingNumber=${confirmationNumber}`
    );
  } catch (err) {
    throw err;
  }
};

export { getHotelById, getBookingByConfirmationNumber };
